import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import React from "react";
import { formatDataRateSmart } from "kontrolEdge/helpers/formatDataRate";

interface DatacenterCapacityChartProps {
  data: {
    name: string;
    value: number;
    color: string;
  }[];
  unit: "Gbps" | "Mbps";
}

export function DataCenterCapacityChart({ data, unit }: DatacenterCapacityChartProps) {
  const toMbps = (v: number) => (unit === "Gbps" ? v * 1000 : v);

  // Sum slices in Mbps so the center label can be "smart"
  const centerMbps = data.reduce((sum, s) => sum + toMbps(s.value), 0);

  return (
    <div style={{ height: '200px' }} className="relative">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            startAngle={180}
            endAngle={-180}
            innerRadius="70%"
            outerRadius="90%"
            paddingAngle={0}
            dataKey="value"
            strokeWidth={0}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center pointer-events-none">
        <span className="text-lg font-semibold">
        <span>
          {/* {formatTwoOrInt(centerValue)} {unit} */}
          {formatDataRateSmart(centerMbps)}
          </span>
        </span>
      </div>
    </div>
  )
}

